
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { TaskflowModel } from './Entities.GormCrm.Taskflow';
import { Model, ModelProperty } from 'models/Model';


export class OrderWarningModel extends Model<OrderWarningModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'orderWarning.property.id', isHidden: true },
		{ name: 'orderId', type: 'guid', languageString: 'orderWarning.property.orderId' },
		{ name: 'comment', type: 'string', languageString: 'orderWarning.property.comment' },
		{ name: 'created', type: 'Date', languageString: 'orderWarning.property.created', isHidden: true },
		{ name: 'createdById', type: 'guid', languageString: 'orderWarning.property.createdById' },
		{ name: 'closed', type: 'Date', languageString: 'orderWarning.property.closed' },
		{ name: 'closedById', type: 'guid', languageString: 'orderWarning.property.closedById' },
		{ name: 'reasonId', type: 'guid', languageString: 'orderWarning.property.reasonId' },
		{ name: 'taskflowId', type: 'guid', languageString: 'orderWarning.property.taskflowId' },
		{ name: 'order', type: 'OrderModel', languageString: 'orderWarning.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'reason', type: 'ReasonModel', languageString: 'orderWarning.property.reason', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'taskflow', type: 'TaskflowModel', languageString: 'orderWarning.property.taskflow', isHidden: true, isObject: true, new: () => { return new TaskflowModel }, properties: () => { return TaskflowModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public comment: string;
	public created?: Date;
	public createdById?: string;
	public closed?: Date;
	public closedById?: string;
	public reasonId?: string;
	public taskflowId?: string;
	public order?: OrderModel;
	public reason?: ReasonModel;
	public taskflow?: TaskflowModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.comment = '';
		this.created = undefined;
		this.createdById = undefined;
		this.closed = undefined;
		this.closedById = undefined;
		this.reasonId = undefined;
		this.taskflowId = undefined;
		this.order = undefined;
		this.reason = undefined;
		this.taskflow = undefined;
		
	}
	getProperties(){
		return OrderWarningModel.classProperties;
	}
}

